import { useEffect, useState } from "react";
import { Modal } from "../CommonUIComponents/Modal/Modal";
import { Button } from "../CommonUIComponents/Button/Button";
import { useI18n } from "../../hooks/useI18n";
import "./CancelOrderModal.scss";

function ModalHeader({ t }) {
  return (
    <span className="motif-subtitle-default-regular">
      {t("cancelOrderModal_title", { defaultValue: "Cancel Order" })}
    </span>
  );
}

function ModalBody({ value, onChange, orderLabel, t }) {
  return (
    <div className="cancel-order-modal-body">
      <p className="cancel-order-modal-message motif-body1-default-light">
        {t("cancelOrderModal_message", {
          defaultValue: "Are you sure you want to cancel the order",
        })}{" "}
        <span className="motif-body1-default-bold">{orderLabel}</span>?
      </p>

      <div className="cancel-order-modal-comment-wrap">
        <label
          className="cancel-order-modal-comment-label motif-body2-default-light"
          htmlFor="cancel-order-comment"
        >
          {t("cancelOrderModal_comment", { defaultValue: "Comment" })}
        </label>
        <textarea
          id="cancel-order-comment"
          className="cancel-order-modal-comment motif-body2-default-light"
          placeholder={t("modal_typeHere", { defaultValue: "Type here" })}
          value={value}
          onChange={onChange}
          rows={2}
        />
      </div>
    </div>
  );
}

function ModalFooter({ onCancel, onConfirm, disabled, loading, t }) {
  return (
    <div className="cancel-order-modal-footer">
      <Button
        variant="secondary"
        size="small"
        onClick={onCancel}
        disabled={loading}
      >
        {t("no", { defaultValue: "No" })}
      </Button>
      <Button
        variant="primary"
        size="small"
        onClick={onConfirm}
        disabled={disabled || loading}
      >
        {t("yes", { defaultValue: "Yes" })}
      </Button>
    </div>
  );
}

export function CancelOrderModal({
  show,
  onClose,
  onConfirm,
  orderId,
  loading = false,
}) {
  const { t } = useI18n();
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (!show) {
      setComment("");
    }
  }, [show]);

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleClose = () => {
    if (loading) return;
    setComment("");
    onClose?.();
  };

  const handleConfirm = () => {
    onConfirm?.({
      orderId,
      comment: comment.trim(),
    });
  };

  const orderLabel = orderId ? `US-${orderId}` : "US-";

  return (
    <Modal
      show={show}
      onClose={handleClose}
      className="cancel-order-modal"
      size="default"
      header={<ModalHeader t={t} />}
      body={
        <ModalBody
          value={comment}
          onChange={handleCommentChange}
          orderLabel={orderLabel}
          t={t}
        />
      }
      footer={
        <ModalFooter
          onCancel={handleClose}
          onConfirm={handleConfirm}
          disabled={!comment.trim()}
          loading={loading}
          t={t}
        />
      }
    />
  );
}
